import classNames from 'classnames';
import React from 'react';

const SwitchBig = ({ label, disable, value, onChange, className, icon = '' }) => {

  return (
    <label className={classNames('form-switch form-switch_big', className, { 'fs-active': value })} onClick={(e) => disable && e.preventDefault()}>
      <span className="fs-label flex items-center gap-1 text-shark-950">
        {icon}
        <span className="label-medium">{label}</span>
      </span>
      <input type="checkbox" checked={value} onChange={onChange} />
      <i className="fsb-switcher" />
    </label>
  );
};

export default SwitchBig;
